/**
 * Mock payload for Reliance Cost Module dashboard.
 * Shape matches expected GET /reliance/cost-dashboard response data.
 */

function departmentSummary(totalHire, totalCost, costPerHire, totalCostPerFunction, avgCostPerFunction) {
  return {
    totalHire,
    totalCost,
    costPerHire,
    totalCostPerFunction,
    avgCostPerFunction,
  }
}

function byFunctionRows() {
  return [
    { functionName: 'Operations', totalCost: 3150000 },
    { functionName: 'Sales', totalCost: 2240000 },
    { functionName: 'Technology', totalCost: 1980000 },
    { functionName: 'Finance', totalCost: 960000 },
    { functionName: 'HR', totalCost: 520000 },
    { functionName: 'Others', totalCost: 625450 },
  ]
}

const COST_TREND_DAILY = {
  labels: ['1 May', '6 May', '11 May', '16 May', '21 May', '26 May', '31 May'],
  values: [1250000, 1420000, 1580000, 1845200, 1720000, 1810000, 1875450],
}

const COST_TREND_WEEKLY = {
  labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5'],
  values: [3200000, 3650000, 4100000, 4450000, 1875450],
}

const COST_TREND_MONTHLY = {
  labels: ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'],
  values: [14200000, 15100000, 15850000, 16500000, 16650000, 18754500],
}

export function getMockCostModuleData() {
  return {
    summary: {
      totalCost: 18754500,
      costPerHire: 78500,
      totalHiringCost: 15200000,
      totalOnboarding: 3545500,
      totalHires: 239,
      offeredPipeline: 86,
      upcomingCost: 4250000,
      trends: {
        totalCost: { value: 12.5, label: 'vs Apr 2024' },
        costPerHire: { value: -3.2, label: 'vs Apr 2024' },
        totalHiringCost: { value: 8.1, label: 'vs Apr 2024' },
        totalOnboarding: { value: 15.4, label: 'vs Apr 2024' },
        totalHires: { value: 6.8, label: 'vs Apr 2024' },
        offeredPipeline: { value: 4.2, label: 'vs last month' },
        upcomingCost: { value: 11.0, label: 'vs last month' },
      },
    },
    costTrend: {
      daily: COST_TREND_DAILY,
      weekly: COST_TREND_WEEKLY,
      monthly: COST_TREND_MONTHLY,
    },
    byDepartment: {
      lateral: departmentSummary(108, 8850000, 81944, 8850000, 81944),
      fteOms: departmentSummary(76, 5748750, 75641, 5748750, 75641),
      fteOsUs: departmentSummary(54, 3982500, 73833, 3982500, 73833),
    },
    byRole: {
      lateral: departmentSummary(95, 7920000, 83474, 7920000, 83474),
      fteOms: departmentSummary(62, 4986000, 80419, 4986000, 80419),
      fteOsUs: departmentSummary(41, 3421000, 83439, 3421000, 83439),
    },
    byFunction: byFunctionRows(),
  }
}

export default getMockCostModuleData
